<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  <p-checkbox
    [ngClass]="[getClass('element', 'control'), getClass('grid', 'control')]"
    [hideLabel]="false"
    [state]="controlState"
    [message]="errorMessages[0]"
    [id]="model.id + '-checkbox'"
    [attr.aria-labelledby]="model.id + '-checkboxLabel'"
    [checked]="model.checked"
    [formControlName]="model.id"
    [indeterminate]="model.indeterminate"
    [name]="model.name"
    [required]="model.required"
    [tabindex]="safeTabIndex"
    [value]="model.value?.toString()"
    (blur)="onBlur($event)"
    (change)="onChange($event)"
    (focus)="onFocus($event)"
  >
    <span slot="label" id="{{ model.id + '-checkboxLabel' }}" [innerHTML]="model.label"></span>
  </p-checkbox>
</div>
